// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-tsx" + "-" + "80fc32bd80ec69dc846d" + ".js";
};